"use client";

import { useEffect } from "react";
import { useUbBottomRightPopupState } from "@/store/ubBottomRightPopupState";

import ResponsiveRichText from "@/components/storyblok/advanced/ResponsiveRichText";
import { UbGlobalBottomRightPopupStoryblok } from "@/components/storyblok/component-types";
import { getSbLocaleFromHostAndUri, removeDefaultLocalesFromUrl } from "@/lib/locale-helper";
import { resolveStoryblokStoryHref } from "@/lib/link-utils/storyblok-link-resolver";

export function CategoryBottomRightPopupClient(props: { settings: UbGlobalBottomRightPopupStoryblok }) {
  const { setCurrentPopupData, setCurrentPopupShow } = useUbBottomRightPopupState()

  useEffect(() => {
    if (props.settings.show_popup && props.settings.body && props.settings.body.length === 1) {
      const linkUrl: string = (() => {
        const sbLocale = typeof window !== "undefined" ? getSbLocaleFromHostAndUri(window.location.hostname, window.location.pathname) : ""
        const link = props.settings.link_btn
        if (link?.linktype === "story") {
          return resolveStoryblokStoryHref(link.cached_url ?? "", sbLocale, link.story)
        }
        const raw = link?.url ?? ""
        if (/^https?:\/\//i.test(raw)) return raw
        const normalized = removeDefaultLocalesFromUrl(raw, sbLocale)
        return normalized || "#"
      })()

      setCurrentPopupData({
        title: props.settings.title,
        body: ResponsiveRichText({ blok: props.settings.body[0] }),
        buttonText: props.settings.label_btn_title,
        buttonUrl: linkUrl,
        imageUrl: props.settings.image?.filename ?? undefined,
      })
      setCurrentPopupShow(true)
    }
    return () => {
      setCurrentPopupShow(false)
      setCurrentPopupData(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.settings])

  return <></>
}
